import { render } from "./fontStyle.vue?vue&type=template&id=8eba8dbc&scoped=true"
import script from "./fontStyle.vue?vue&type=script&lang=js"
export * from "./fontStyle.vue?vue&type=script&lang=js"

import "./fontStyle.vue?vue&type=style&index=0&id=8eba8dbc&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eba8dbc"]])

export default __exports__